/** @format */

import styled from "styled-components"
import { colorPalette } from "@ui-library/myslpro"
import { colorPalette as colorPalette2 } from "_shared/styles/color"
import { SkeletonLoaderDiv } from "_shared/styles/skeletonLoader"
export const TableContainer = styled.div`

  table {
    display: table;
    width: 100%;
    border-collapse: collapse;
    background-color: white;
    font-size: 16px;

    th,
    td {
      &.size-1 {
        width: 11%;
      }
      &.size-2 {
        width: 21%;
      }
      &.size-3 {
        width: 30%;
      }
      &.size-4 {
        width: 40%;
      }
      &.size-5 {
        width: 50%;
      }
    }

    

    thead {
      width: 100%;

      tr {
        width: 100%;

        th {
          padding: 16px;
          font-weight: bold;
          line-height: 1.25;
          color: ${colorPalette.greyDark}};
          text-align: left;
          border-bottom: 1px solid ${colorPalette2.greyLightBis};
        }
      }
    }

    tbody {

      tr {
        width: 100%;
        border-bottom: 1px solid ${colorPalette2.greyLightBis};

        &:hover {
          border-radius: 8px;
          box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
        }

        td {
            padding: 16px;
            position: relative;
            &:not(:last-child):after{
                content: '';
                background-color: ${colorPalette.greyLighter};
                position: absolute;
                left: 100%;
                top: 12px;
                bottom: 12px;
                width: 1px;
            }
        }


      }
    }
  }
`
export const LabelContainer = styled(SkeletonLoaderDiv)`
  display: flex;
  gap: 10px;
  ${props => props.isLoading && 'max-width: 180px;'}
  div{
      width: unset;
      height: unset;
  }
`